/* global process */
import {urlFriendlyString} from "../string";
import {onlineFileExists} from "../url";

export const exportableStatements = async (
  filenamePrefix,
  customerName,
  energyType,
  date,
  gettext,
) => {
  const { REACT_APP_STATIC_URL } = process.env;
  const returnArray = [];
  let optionLabel = gettext("Export Statement");
  switch (filenamePrefix) {
    case "energy-statement":
      optionLabel = gettext("Energy Report");
      break;
    case "climate-statement":
      optionLabel = gettext("Climate Report");
      break;
    default:
      // Do nothing
      break;
  }

  if (date) {
    const year = new Date(date).getFullYear();
    const fileName = urlFriendlyString(
      filenamePrefix + "-" + customerName + "-" + energyType + "-" + year,
    );
    const obj = {
      label: optionLabel,
      url: `${REACT_APP_STATIC_URL}/excel/${fileName}.xlsx`,
    };

    const fileFound = await onlineFileExists(
      `${REACT_APP_STATIC_URL}/excel/${fileName}.xlsx`,
    );

    if (fileFound) {
      returnArray.push(obj);
    }
  } else {
    const fileName = urlFriendlyString(
      filenamePrefix + "-" + customerName + "-" + energyType,
    );
    const obj = {
      label: optionLabel,
      url: `${REACT_APP_STATIC_URL}/excel/${fileName}.xlsx`,
    };
    returnArray.push(obj);
  }

  return returnArray;
};
